import { render } from "./PrivacyData.vue?vue&type=template&id=0bbfec9a&scoped=true"
import script from "./PrivacyData.vue?vue&type=script&lang=js"
export * from "./PrivacyData.vue?vue&type=script&lang=js"

import "./PrivacyData.vue?vue&type=style&index=0&id=0bbfec9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbfec9a"]])

export default __exports__